<template>
  <div>
    <div class="datalist">
      <div class="xzq">
        <el-select
          @change="fixmanchange"
          v-model="fixmanid"
          placeholder="请选择技术人员"
        >
          <el-option value="0" label="全部"></el-option>
          <el-option
            v-for="item in fixmans"
            :key="item.fid"
            :label="item.man_name"
            :value="item.fid"
          ></el-option>
        </el-select>
      </div>
      <div>
        <el-table
          v-loading="loading"
          :data="tableData"
          :row-class-name="tableRowClassName"
          border
          style="width: 100%; margin-top: 50px"
        >
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column
            width="100px"
            prop="module"
            label="BUG模块"
          ></el-table-column>
          <el-table-column width="350px" label="BUG图片">
            <template slot-scope="scope">
              <div style="display: flex; overflow: auto">
                <li
                  style="flex: 1"
                  v-for="item in scope.row.img"
                  :key="item.id"
                >
                  <img
                    style="max-width: 80px; padding: 8px 6px"
                    :src="item.url"
                    @click="getimages(scope.row.img, item.url)"
                  />
                </li>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="100px"
            prop="fixman"
            label="技术员"
          ></el-table-column>
          <el-table-column
            width="120px"
            label="是否解决"
            prop="solve"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top-start"
              >
                <a
                  href="#"
                  @click="edit(scope.row, 'look')"
                  style="margin-left: 10px"
                  >查看详情</a
                >
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="已经解决"
                placement="top-start"
              >
                <a
                  class="solvebtn"
                  href="#"
                  @click="solveitemadd(scope.row, 'solve')"
                  style="margin-left: 10px"
                  >我已解决</a
                >
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-size="pagesize"
        layout=" prev, pager, next"
        :total="pagetotal"
      ></el-pagination>
    </div>
    <div>
      <el-dialog
        title="BUG表单"
        :inline="true"
        class="demo-form-inline dialog"
        width="80%"
        style="margin-top: -11vh !important"
        :visible.sync="dialogFormVisible"
      >
        <div class="formbiaodan">
          <el-form v-model="form">
            <el-input
              type="hidden"
              style="width: 300px"
              placeholder="请输入名称"
              v-model="form.id"
            ></el-input>

            <el-row>
              <el-col :span="12" style="position: relative">
                <span
                  style="
                    position: absolute;
                    color: red;
                    font-size: 1px;
                    top: 14px;
                    left: -13px;
                  "
                  class="el-icon-star-off"
                ></span>
                <el-form-item label="BUG问题模块:">
                  <el-select
                    :disabled="watch"
                    v-model="form.moduleid"
                    style="width: 300px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in bugmodules"
                      :key="item.id"
                      :label="item.module_name"
                      :value="item.mid"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="position: relative">
                <span
                  style="
                    position: absolute;
                    color: red;
                    font-size: 1px;
                    top: 14px;
                    left: -13px;
                  "
                  class="el-icon-star-off"
                ></span>
                <el-form-item label=" 技术员:" prop="name">
                  <el-select
                    :disabled="watch"
                    v-model="form.fixmanid"
                    style="width: 300px"
                    placeholder="请选择技术员"
                  >
                    <el-option
                      v-for="item in fixmans"
                      :key="item.id"
                      :label="item.man_name"
                      :value="item.fid"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" style="display: flex; position: relative">
                <span
                  style="
                    position: absolute;
                    color: red;
                    font-size: 1px;
                    top: 14px;
                    left: -13px;
                  "
                  class="el-icon-star-off"
                ></span>
                <el-form-item label="BUG内容:">
                  <br />
                  <div class="wendang" v-show="watch">
                    <p v-html="wentext"></p>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog title="修改BUG状态" :visible.sync="dialogFormVisible2">
        <span class="solvetip"
          >当前正在修改<i style="color: red">{{ solvemodel }}</i
          >下<i style="color: red">{{ solveman }}</i
          >负责的BUG,请确认是否已完成</span
        >
        <el-form class="formsolve" :model="form">
          <el-form-item class="formsolveitem" label="验证码 :">
            <el-input
              class="solveinput"
              v-model="yzm"
              autocomplete="off"
              placeholder="请输入BigeMap验证码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="solvetijiao()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="watchimage" v-show="imageshow">
      <span class="el-icon-close" @click="imageshow = false"></span>
      <el-carousel indicator-position="outside">
        <el-carousel-item v-for="item in images" :key="item">
          <img class="hdpimg" :src="item.url" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      fixmanid: "0",
      loading: true,
      tableData: [],
      form: {
        id: "",
        moduleid: "",
        fixmanid: "",
        text: "",
        image: [],
        solve: "0",
      },
      wentext: "",
      watch: true,
      editsolves: [
        {
          value: 0,
          label: "未解决",
        },
        {
          value: 1,
          label: "已解决",
        },
        {
          value: 2,
          label: "搁置",
        },
      ],
      solvshow: true,
      fixmans: [],
      bugmodules: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      currentPage2: 1,
      pagesize: 10,
      pagetotal: 0,
      imageshow: false,
      images: [],
      solvemodel: "aa",
      solveman: "aaa",
      solveitem: "",
      yzm: "",
    };
  },
  mounted() {
    this.getset();
    this.getdata();
  },
  methods: {
    getdata(fixmanid = 0) {
      let that = this;
      let pages = {
        num: this.pagesize,
        page: this.currentPage2,
      };
      this.$axios
        .post("http://api.bigemap.com/bug/index/getdata2", {
          pages: JSON.parse(JSON.stringify(pages)),
          name: fixmanid > 0 ? fixmanid : "",
        })
        .then((res) => {
          res = res.data;

          if (res.code == 200) {
            that.tableData = res.data;
            that.pagetotal = res.count;
            that.loading = false;
          } else {
            this.$message.error("服务区打盹了,请稍后重试.....");
          }
        });
    },
    getset() {
      let that = this;
      this.$axios
        .post("http://api.bigemap.com/bug/index/getset")
        .then((res) => {
          res = res.data;
          if (res.code == 200) {
            that.fixmans = res.data.fixmans;
            that.bugmodules = res.data.modules;
          } else {
            this.$message.error("服务区打盹了,请稍后重试.....");
          }
        });
    },
    getimages(row, url) {
      this.imageshow = true;
      let that = this;
      this.images = row;
      this.images.map((v, i) => {
        if (v.url == url) that.imgdef = i;
      });
    },
    fixmanchange() {
      let num = parseInt(this.fixmanid);
      this.getdata(num);
    },
    handleSizeChange(val) {
      //todo 数据库查询
      this.pagesize = val;
      this.getdata(this.pagesize, this.currentPage2);
    },
    handleCurrentChange(val) {
      this.currentPage2 = val;
      this.getdata(this.pagesize, this.currentPage2);
    },
    tableRowClassName({ row }) {
      if (row.sovlenum === 0) {
        return "warning-row";
      } else if (row.sovlenum === 1) {
        return "success-row";
      }
      return "gezhi-row";
    },
    edit(data, type) {
      if (type == "look") {
        this.solvshow = true;
        this.form.id = data.id;
        this.form.moduleid = parseInt(data.moduleid);
        this.form.leavel = data.leavelnum + "";
        this.form.fixmanid = parseInt(data.fixmanid);
        this.editcontent = data.text;
        this.form.text = data.text;
        this.form.image = data.img;
        this.form.solve = parseInt(data.sovlenum);
        this.dialogFormVisible = true;
        this.wentext = data.text ? data.text : "暂无内容";
        this.watch = true;
      }
    },
    solveitemadd(data, type) {
      this.dialogFormVisible2 = !this.dialogFormVisible2;
      this.solvemodel = data.module;
      this.solveman = data.fixman;
      this.solveitem = data;
    },
    solvetijiao() {
      this.$axios
        .post("http://api.bigemap.com/bug/index/editsovleyzm", {
          id: this.solveitem.id,
          solve: 1,
          yzm: this.yzm,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.yzm = "";
            this.solveitem = "";
            this.getdata();
            this.dialogFormVisible2 = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
  },
};
</script>

<style scoped>
.datalist {
  height: 89vh;
  width: 95vw;
  overflow: auto;
  position: relative;
  text-align: center;
  left: 50%;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  box-shadow: 0px 1px 1px black;
  margin-top: 30px;
}
.xzq {
  position: absolute;
  top: 0px;
  right: 30px;
}
.watchimage {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 634px;
  transform: translate(-40%, -50%);
}
.hdpimg {
  max-height: 500px;
  max-width: 500px;
}
.watchimage span {
  right: 11px;
  position: absolute;
  z-index: 99;
  top: 7px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #d3dce6;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.el-carousel__item {
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
}
.el-dialog {
  margin: 0 auto !important;
}
a {
  text-decoration: none;
}
.solvebtn {
  margin-left: 23px !important;
}
.formsolve {
  display: flex;
  flex-direction: column;
}
.formsolveitem {
  flex: 1;
  width: 100%;
  display: flex;
  margin-top: 20px;
}
.solveinput {
  width: 550px;
}
.solvetip {
  font-size: 20px;
}
</style>